/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { CreateUserAction } from '../../../redux/actions/user';
import { CREATE_USER_RESET } from '../../../redux/constantes/user';

import { ContainerForm } from '../../../components/Containers';
import InputUser from '../../../components/User/InputUser';
import SelectCreate from '../../../components/User/SelectCreate';
import SelectCreateSincroniza from '../../../components/User/SelectCreateSincroniza';
import ButtonShowOrHidePassword from '../../../components/User/ButtonShowOrHidePassword';
import { WrapperPassword } from '../../../components/User/WrapperPassword';
import { WrapperListCompanies } from '../../../components/User/WrapperListCompanies';
import CompanyOption from '../../../components/User/CompanyOption';
import AccessMode from '../../../components/User/AccessMode';
import { WrapperButtons } from '../../../components/WrapperButtons';
import ButtonSend from '../../../components/ButtonSend';
import ButtonBack from '../../../components/ButtonBack';
import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../../../components/MessageBox';
import HiringMode from '../../../components/User/HiringMode';
import AccessModeSincroniza from '../../../components/User/AccessModeSincroniza';
import HeaderTitle from '../../../components/HeaderTitle';

export default function TemplateUserReg() {
  const { success: successCreate, error: errorCreate } = useSelector((state) => state.createUser);
  const { userInfo } = useSelector((state) => state.userSign);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [typePassword, setTypePassword] = useState('password');
  const [companiesName, setCompaniesName] = useState([]);
  const [companiesId, setCompaniesId] = useState([]);
  const [accessMode, setAccessMode] = useState('');
  const [hiringMode, setHiringMode] = useState('');
  const [CPF, setCPF] = useState('');
  const [CNPJ, setCNPJ] = useState('');
  const [nameCompany, setNameCompany] = useState('');
  const [passwordAlert, setPasswordAlert] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (successCreate) {
      setTimeout(() => {
        dispatch({ type: CREATE_USER_RESET });
        document.location.href = '/';
      }, 2000);
    }
    if (errorCreate) {
      setTimeout(() => {
        dispatch({ type: CREATE_USER_RESET });
      }, 3000);
    }
  }, [dispatch, successCreate, errorCreate]);

  const handleSubmit = () => {
    dispatch(
      CreateUserAction(
        name,
        email,
        password,
        confirmPassword,
        companiesId,
        accessMode,
        hiringMode,
        CPF,
        CNPJ,
        nameCompany,
      ),
    );
  };

  return (
    <ContainerForm>
      {userInfo !== null && (
        <section>
          <HeaderTitle text="Cadastrar Usuário" linkIcon="/images/icons/user-stroke.svg" />
          <InputUser
            label="Nome"
            type="text"
            onChange={(e) => setName(e.target.value)}
            value={name}
            placeholder="Digite o nome completo"
          />
          <InputUser
            label="E-mail"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            placeholder="exemplo@email.com"
          />
          <InputUser
            label="Senha"
            type={typePassword}
            onFocus={() => setPasswordAlert(true)}
            onBlur={() => setPasswordAlert(false)}
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          <WrapperPassword>
            <InputUser
              label="Confirmação de senha"
              type={typePassword}
              onFocus={() => setPasswordAlert(true)}
              onBlur={() => setPasswordAlert(false)}
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
            />
            <ButtonShowOrHidePassword typePassword={typePassword} setTypePassword={setTypePassword} />
          </WrapperPassword>
          <HiringMode
            setHiringMode={setHiringMode}
            hiringMode={hiringMode}
            setCPF={setCPF}
            CPF={CPF}
            setNameCompany={setNameCompany}
            nameCompany={nameCompany}
            setCNPJ={setCNPJ}
            CNPJ={CNPJ}
          />
          {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
            <SelectCreate
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
            <SelectCreateSincroniza
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
            <SelectCreateSincroniza
              companiesName={companiesName}
              setCompaniesName={setCompaniesName}
              setCompaniesId={setCompaniesId}
            />
          )}
          <WrapperListCompanies>
            {companiesName.map((comp, index) => {
              return (
                <CompanyOption
                  key={index + 1}
                  comp={comp}
                  index={index}
                  companiesName={companiesName}
                  companiesId={companiesId}
                  setCompaniesName={setCompaniesName}
                  setCompaniesId={setCompaniesId}
                />
              );
            })}
          </WrapperListCompanies>
          {userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS && (
            <AccessMode
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS && (
            <AccessModeSincroniza
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          {userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS && (
            <AccessModeSincroniza
              value={accessMode}
              modifyFunction={setAccessMode}
              labelText="Escolha o modo de acesso do Usuário:"
            />
          )}
          <WrapperButtons>
            <ButtonBack />
            <ButtonSend onClick={handleSubmit}>Cadastrar</ButtonSend>
          </WrapperButtons>
        </section>
      )}
      {successCreate && <MessageBoxSuccess>Usuário cadastrado com sucesso!</MessageBoxSuccess>}
      {errorCreate && <MessageBoxError>{errorCreate}</MessageBoxError>}
      {passwordAlert && (
        <MessageBoxAlert>
          A senha deve conter no minimo 8 dígitos, letras maiúsculas, minusculas e números.
        </MessageBoxAlert>
      )}
    </ContainerForm>
  );
}
